import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
// InfoBox,
const containerStyle = {
  width: "100%",
  height: "400px",

  marginBottom: "30px",
};
const option = {
  mapTypeControl: false,
  streetViewControl: false,
};

const center = {
  lat: 34.64137957706596,
  lng: 135.54292141259575,
};
// const options = { closeBoxURL: "", enableEventPropagation: true };

// const onLoad = (infoBox) => {
//   console.log("infoBox: ", infoBox);
// };

function Map() {
  return (
    <LoadScript googleMapsApiKey="AIzaSyBHAIPSDg5oWH9PsSpNV0pjFZgDO3rv99Y">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={18}
        options={option}
      >
        {/* Child components, such as markers, info windows, etc. */}

        <>
          <Marker position={center} />
          {/* <InfoBox onLoad={onLoad} options={options} position={center}>
            <div
              style={{ backgroundColor: "yellow", opacity: 0.75, padding: 12 }}
            >
              <div style={{ fontSize: 16, fontColor: `#08233B` }}>
                Hello, World!
              </div>
            </div>
          </InfoBox> */}
        </>
      </GoogleMap>
    </LoadScript>
  );
}

export default React.memo(Map);
